import { type Component } from 'solid-js';
import History from '~/features/history';

// The record: what each fund's price did on its own, and what a position opened
// at its first bar would be worth now. Full width — both tables are wide, and
// the erosion one is only readable with capital and income side by side.
const HistoryPage: Component = () => (
    <div class='flex-1 min-w-0'>
        <History />
    </div>
);

export default HistoryPage;
